import { useTranslations } from 'next-intl';
import React from 'react';
import { BillingData } from '@winelivery-org/wl-client-sdk-js';

interface Props {
  setIsInvoiceFormVisible: () => void;
  invoice: BillingData;
}

export const InvoiceInfo = ({
  setIsInvoiceFormVisible,
  invoice,
}: Props) => {
  const t = useTranslations('common');

  return (
    <>
      <div onClick={setIsInvoiceFormVisible}
           className="tw-px-5 tw-py-3 tw-rounded-md tw-border tw-border-greyscale-gray-light tw-bg-white hover:tw-bg-greyscale-gray-lighter tw-m-0 tw-mb-1">
        <div
          className="tw-flex max-sm:tw-flex-col max-sm:tw-gap-2 tw-py-3 tw-border-t first:tw-border-t-0 tw-border-t-greyscale-gray-light">
          <div className="md:tw-w-1/3 sm:tw-w-1/2 tw-text-greyscale-gray">
            {t('InvoiceSection.Invoice.intestazione')}
          </div>
          <div className="md:tw-w-2/3 sm:tw-w-1/2">
            {invoice.businessName}
          </div>
        </div>
        <div
          className="tw-flex max-sm:tw-flex-col max-sm:tw-gap-2 tw-py-3 tw-border-t first:tw-border-t-0 tw-border-t-greyscale-gray-light">
          <div className="md:tw-w-1/3 sm:tw-w-1/2 tw-text-greyscale-gray">
            {t('InvoiceSection.Invoice.indirizzo')}
          </div>
          <div className="md:tw-w-2/3 sm:tw-w-1/2">
            {invoice.address}
          </div>
        </div>
        {invoice.vat && (
          <div
            className="tw-flex max-sm:tw-flex-col max-sm:tw-gap-2 tw-py-3 tw-border-t first:tw-border-t-0 tw-border-t-greyscale-gray-light">
            <div className="md:tw-w-1/3 sm:tw-w-1/2 tw-text-greyscale-gray">
              {t('InvoiceSection.Invoice.vat')}
            </div>
            <div className="md:tw-w-2/3 sm:tw-w-1/2">
              {invoice.vat}
            </div>
          </div>
        )}
        {invoice.socialSecurityNumber && (
          <div
            className="tw-flex max-sm:tw-flex-col max-sm:tw-gap-2 tw-py-3 tw-border-t first:tw-border-t-0 tw-border-t-greyscale-gray-light">
            <div className="md:tw-w-1/3 sm:tw-w-1/2 tw-text-greyscale-gray">
              {t('InvoiceSection.Invoice.ssn')}
            </div>
            <div className="md:tw-w-2/3 sm:tw-w-1/2">
              {invoice.socialSecurityNumber}
            </div>
          </div>
        )}
        <div
          className="tw-flex max-sm:tw-flex-col max-sm:tw-gap-2 tw-py-3 tw-border-t first:tw-border-t-0 tw-border-t-greyscale-gray-light">
          <div className="md:tw-w-1/3 sm:tw-w-1/2 tw-text-greyscale-gray">
            {t('InvoiceSection.Invoice.pec')}
          </div>
          <div className="md:tw-w-2/3 sm:tw-w-1/2">
            {invoice.pec}
          </div>
        </div>
      </div>
      <span className="tw-text-balance">
        <em>{t('InvoiceForm.invoice-description')}</em>
      </span>
    </>
  );
};
